export type EmbroideryFont = 'bubble' | 'script' | 'block'

export function normalizeEmbroideryCharacter(
	_font: EmbroideryFont,
	value: string
) {
	return value.toUpperCase()
}

export function supportsEmbroideryCharacter(
	font: EmbroideryFont,
	value: string
) {
	if (font === 'block') return true
	return font === 'bubble'
		? /^[A-Z]$/.test(value)
		: /^[A-Za-z0-9]$/.test(value)
}

export function embroideryGlyphUrl(
	font: EmbroideryFont,
	value: string,
	assetUrl: string
) {
	if (
		font === 'block' ||
		!supportsEmbroideryCharacter(font, value) ||
		!assetUrl
	)
		return ''
	const family = font === 'bubble' ? 'bubblegum' : 'script'
	const codepoint = value.codePointAt(0)?.toString(16)
	return assetUrl.replace(
		'embroidery-font-bubblegum-41.svg',
		`embroidery-font-${family}-${codepoint}.svg`
	)
}
